import axios from "axios";
import keycloak from "./Keycloak";

const createAxios = () => axios.create({
    baseURL:
        (!window.g_baseUrl?.startsWith('%')
            ? window.g_baseUrl
            : null) ??
        process.env.REACT_APP_BASE_URL ??
        '/wo',
    headers: {
        Authorization: "Bearer " + keycloak.token,
        ContentType: "application/json"
    }
});

export default createAxios;
